const addZero = (value: number): string => `${value < 10 ? '0' : ''}${value}`;
export default addZero;
